<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-10 20:56:30
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:19:07
--> 
<template>
  <div style="position: relative">
    <div>
      <span class="ft2">
        {{ label }}
      </span>
    </div>
    <!-- <div v-if="disabled"
         style="background-color:red;height:150px;position:absolute;width:100%;z-index:6;opacity:0"></div> -->
    <div v-if="disabled">
      <div class="bigbox" @click="fileInfo.path ? enlarge() : ''">
        <div class="pr-6">
          <!-- :lazy-src="`https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1367612770,3823804625&fm=26&gp=0.jpg`" -->
          <v-img
            :src="fileInfo.path"
            v-if="fileInfo.path"
            width="96"
            height="96"
            class="grey darken-4"
          >
            <template v-slot:placeholder>
              <v-progress-circular
                :size="96"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </template>
          </v-img>
          <mrc_ess_svgIcon
            icon-class="noimg"
            v-else
            style="font-size: 96px"
          ></mrc_ess_svgIcon>
        </div>
        <div
          class="d-flex justify-space-between"
          v-if="fileInfo.path"
          style="width: 100%"
        >
          <span>
            <span>{{ fileInfo.name }}</span
            ><br />
            <span>{{ fileInfo.size | unitConversion }}</span>
          </span>
          <span
            @click="deleteicon"
            v-if="!disabled"
            style="position: relative; z-index: 7; padding-top: 10px"
            class="pr-3"
          >
            <v-icon> mdi-delete</v-icon>
          </span>
          <span v-else> </span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="bigbox" @click="enlarge" v-if="fileInfo.path">
        <div class="pr-6">
          <!-- :lazy-src="`https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1367612770,3823804625&fm=26&gp=0.jpg`" -->
          <v-img
            :src="fileInfo.path"
            width="96"
            height="96"
            class="grey darken-4"
          >
            <template v-slot:placeholder>
              <v-progress-circular
                :size="96"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </template>
          </v-img>
        </div>
        <div class="d-flex justify-space-between" style="width: 100%">
          <span>
            <span>{{ fileInfo.name }}</span
            ><br />
            <span>{{ fileInfo.size | unitConversion }}</span>
          </span>
          <span
            @click="deleteicon"
            v-if="!disabled"
            style="position: relative; z-index: 7; padding-top: 10px"
            class="pr-3"
          >
            <v-icon> mdi-delete</v-icon>
          </span>
          <span v-else> </span>
        </div>
      </div>

      <div class="box" v-else>
        <mrc_ess_fileInput
          :accept="accept"
          :uploadFileType="uploadFileType"
          @changeimgSrc="changeimgSrc"
        ></mrc_ess_fileInput>
        <v-icon class="material-icons" style="color: #e0e0e0; font-size: 64px">
          cloud_upload
        </v-icon>
        <div class="d-flex mt-4 align-center">
          <span>{{ $t("label_dropFilesToUpload") }},{{ $t("label_or") }}</span>
          <v-btn
            rounded
            depressed
            color="#C6DBFD"
            class="ml-3 text-capitalize primary--text"
            dark
            >{{ $t("label_browse") }}
          </v-btn>
        </div>
        <span class="text--secondary mt-2">
          {{
            UploadFormatText
              ? UploadFormatText
              : "*" + $t("label_bestResolution") + "96*96 px,png"
          }}
        </span>
      </div>
    </div>
    <mrc_ess_myDialog
      v-model="dialog"
      :hiddenTitle="true"
      :disabled="false"
      width="750"
      :title="fileInfo.name"
    >
      <v-img
        :src="fileInfo.path"
        width="700"
        height="700"
        class="grey darken-4"
      ></v-img>
    </mrc_ess_myDialog>
  </div>
</template>

<script>
/*
 * @params fileInfo  接受文件信息
 * @params uploadFileType 上传文件类型验证
 * @event deleteicon 删除商家图标事件
 * @event changeisShow 隐藏
 * @changeimgSrc  返回file对象
 */
import { findSrc } from "@/service/api/upload.js";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    uploadFileType: {
      //上传文件规则
      default: () => {
        return /\.(png|jpg|gif|jpeg|webp|PNG)$/;
      },
    },
    UploadFormatText: {
      type: String,
    },
    accept: {
      type: String,
      default: "image/*",
    },
    label: {
      type: String,
    },
    uuid: {
      type: String,
    },
  },
  model: {
    prop: "uuid",
    event: "changeuuid",
  },
  filters: {
    unitConversion(v) {
      return (Number(v) / 1024 / 1024).toFixed(2) + "M";
    },
  },
  data() {
    return {
      fileInfo: {},
      dialog: false,
      // srcimg: '',
    };
  },
  computed: {},
  created() {},
  watch: {
    uuid(val) {
      this.getPath(val);
    },
  },
  async mounted() {
    await this.getPath(this.uuid);
  },
  methods: {
    async getPath(val) {
      if (!val) return;
      findSrc({ uuid: val }).then((res) => {
        if (res.data.files.length > 0) {
          this.fileInfo = res.data.files[0];
        } else {
          this.fileInfo = {};
        }
      });
    },
    enlarge() {
      this.dialog = true;
    },
    deleteicon(v) {
      this.$emit("deleteicon", {
        ...this.fileInfo,
        uuid: this.uuid,
      });
      this.$emit("changeuuid", "");
      this.fileInfo = {};
      this.$emit("changeimgSrc", []);
    },
    changeimgSrc(v) {
      this.fileInfo = {
        path: window.URL.createObjectURL(v[0]),
        name: v[0].name,
        size: v[0].size,
      };
      this.$emit("changeimgSrc", v);
    },
    fileChange(v) {},
  },
};
</script>

<style scoped>
.bigbox {
  position: relative;
  background-color: #ffffff;
  width: 100%;
  min-height: 112px;
  border: 1px solid #e0e0e0;
  padding-left: 8px;
  display: flex;
  justify-items: center;
  align-items: center;
}
.box {
  position: relative;
  background-color: #ffffff;
  border: 3px dashed #e0e0e0;
  width: 100%;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.ft2 {
  font-family: var(--body-font-family);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.6);
}
</style>
